import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { toastr } from 'react-redux-toastr';

import Input from '../../../../bergmannsoft/components/Widgets/Forms/Input';

import './styles.scss';
import InputDropdown from '../../../../bergmannsoft/components/Widgets/Forms/InputDropdown';

import ImageCrop from '../../../../components/ImageTools/index';
import imgProfile from '../../../../assets/images/user_no_profile_photo.svg';

export default (props) => {
  const { i18n } = useTranslation();
  const claimIsRoot = useSelector((state) => state.users?.signedUserIsRoot);

  const { organizations, user, permissions } = props;
  // const { signedUser } = useSelector((state) => state.users);
  const companyId = useSelector(
    (state) => state.users.signedUser.selectedCompany._id
  );

  const [name, setName] = useState('');
  const [cpf, setCpf] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const [phone, setPhone] = useState('');
  const [cep, setCep] = useState('');
  const [address, setAddress] = useState('');
  const [addressNeighborhood, setAddressNeighborhood] = useState('');
  const [addressCity, setAddressCity] = useState('');
  const [addressState, setAddressState] = useState('');
  const [addressCountry, setAddressCountry] = useState('');
  const [email, setEmail] = useState('');
  const [profilePhoto, setProfilePhoto] = useState('');
  const [checkedOrganizations, setCheckedOrganizations] = useState([]);
  const [checkedOrganizationsIds, setcheckedOrganizationsIds] = useState([]);
  const [checkedPermissions, setCheckedPermissions] = useState([]);
  const [codeUser, setCodeUser] = useState('');
  const [orgsCompany, setOrgsCompany] = useState([]);
  const [permissionsUser, setPermissionsUser] = useState([]);

  useEffect(() => {
    if (user) {
      setName(user.name || '');
      setCpf(user.cpf || '');
      setBirthDate(user.birthDate || '');
      setPhone(user.phone || '');
      setCep(user.cep || '');
      setAddress(user.address || '');
      setAddressNeighborhood(user.addressNeighborhood || '');
      setAddressCity(user.addressCity || '');
      setAddressState(user.addressState || '');
      setAddressCountry(user.addressCountry || '');
      setEmail(user.email || '');
      setCodeUser(user.codeUser || '');
      setProfilePhoto(user.profilePhoto || imgProfile);
    }

    if (companyId && orgsCompany.length === 0) {
      let orgArray = [];

      orgArray = organizations.filter((org) => {
        return org.companyId === companyId;
      });

      setOrgsCompany(orgArray);
    }

    if (permissionsUser.length === 0) {
      let permissionsArray = [];

      if (!claimIsRoot) {
        permissionsArray = permissions.filter((element) => {
          return element.name !== 'Root';
        });
      } else {
        permissionsArray = permissions;
      }
      setPermissionsUser(permissionsArray);
    }
  }, [orgsCompany, permissionsUser]);

  useEffect(() => {
    if (checkedOrganizations.length === 0 && user && user.organizations) {
      const arrayOrgs = user.organizations.filter((element) => {
        if (element.companyId === companyId) {
          return element._id;
        }
      });
      setCheckedOrganizations(arrayOrgs || []);
    }

    if (user && checkedOrganizationsIds.length === 0) {
      const orgIdsArray = checkedOrganizations.map((item) => {
        return item._id;
      });

      setcheckedOrganizationsIds(orgIdsArray);
    }
  }, [checkedOrganizations, checkedOrganizationsIds]);

  useEffect(() => {
    if (checkedPermissions.length === 0 && user && user.claim) {
      const claimsCompany = user.claim.find((element) => {
        return (
          element.companyId === companyId ||
          element.companyId.toString() === companyId.toString()
        );
      });
      setCheckedPermissions(claimsCompany);
    }
  }, [checkedPermissions]);

  const save = () => {
    if (!checkedPermissions || checkedPermissions.length === 0) {
      toastr.error(i18n.t('Erro'), i18n.t('Selecione uma permissão.'));
    }

    if (!checkedOrganizations || checkedOrganizations.length === 0) {
      toastr.error(
        i18n.t('Erro'),
        i18n.t('Selecione pelo menos uma organização.')
      );
    } else {
      const orgs =
        checkedOrganizations.length >= 1
          ? checkedOrganizations.map((el) => {
              return el?._id ? el?._id : el;
            })
          : checkedOrganizations;

      const data = {
        _id: user._id,
        organizationIds: Array.isArray(orgs) ? orgs : [orgs],
        claim: checkedPermissions.name,
        codeUser,
        profilePhoto,
        companyId,
      };
      const { updatePermission } = props;
      updatePermission(data);
    }
  };

  const readFileAsync = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  const atualizaProfilePhoto = async (blob) => {
    const img = await readFileAsync(blob);
    setProfilePhoto(img);
  };

  const onProfilePhotoChanged = (files) => {
    if (files && files.length > 0) {
      const file = files[0];
      console.log(file);
      if (!file.type) {
        toastr.error(
          i18n.t('Erro'),
          i18n.t('Não foi possível identificar o tipo do arquivo.')
        );
      } else if (
        file.type !== 'image/png' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/jpeg'
      ) {
        toastr.error(
          i18n.t('Erro'),
          i18n.t(
            'O arquivo precisa ser em um desses formatos: .png, .jpg, .jpeg'
          )
        );
      } else {
        const reader = new FileReader();
        reader.onload = (e) => {
          const image = new Image();
          image.src = e.target.result;
          console.log('image.src', image.src.length);
          image.onload = () => {
            if (image.width !== 80 || image.height !== 80) {
              toastr.error(
                i18n.t('Erro'),
                i18n.t(
                  `A imagem deve ser 80x80. A imagem escolhida tem ${image.width}x${image.height}`
                )
              );
            } else {
              setProfilePhoto(e.target.result);
            }
          };
        };
        reader.readAsDataURL(file);
      }
    }
  };
  return (
    <Fragment>
      <div id="iconModal" className="modal fade" role="dialog">
        <div className="modal-dialog modal-dialog-img">
          <ImageCrop atualizaBotFab={atualizaProfilePhoto} />
        </div>
      </div>

      <div className="settings-content-card-settings user-edit mb-4">
        <div className="row">
          <div className="col-md-2">
            <img
              className="profile-photo click-pointer"
              id="photo-profile"
              data-toggle="modal"
              data-target="#iconModal"
              src={profilePhoto}
              alt=""
            />

            <input
              id="profile-photo"
              className="hide"
              type="file"
              accept="image/png"
              onChange={(e) => onProfilePhotoChanged(e.target.files)}
            />
          </div>
          <div className="col-md-10">
            {/* nome, cpf */}
            <div className="row ml-4">
              <div className="col-md-6">
                <Input
                  className="settings-content-modal-input ipt-rev"
                  disabled
                  label={i18n.t('Nome')}
                  value={name}
                  onChange={(value) => {
                    setName(value);
                  }}
                />
              </div>
              <div className="col-md-3 ml-2">
                <Input
                  className="settings-content-modal-input ipt-rev"
                  disabled
                  label={i18n.t('CPF')}
                  value={cpf}
                  onChange={(value) => {
                    setCpf(value);
                  }}
                />
              </div>
            </div>
            {/* nasc, telefone */}
            <div className="row ml-4">
              <div className="col-md-3">
                <Input
                  className="settings-content-modal-input ipt-rev"
                  disabled
                  label={i18n.t('Nasc')}
                  value={birthDate}
                  onChange={(value) => {
                    setBirthDate(value);
                  }}
                />
              </div>
              <div className="col-md-4 ml-2">
                <Input
                  className="settings-content-modal-input ipt-rev"
                  disabled
                  label={i18n.t('Telefone')}
                  value={phone}
                  onChange={(value) => setPhone(value)}
                  mask="(99) 99999 9999"
                  maskChar=" "
                />
              </div>
            </div>
          </div>
        </div>

        <hr />

        {/* cep, rua */}
        <div className="row">
          <div className="col-md-2 ml-1">
            <Input
              className="settings-content-modal-input ipt-rev"
              disabled
              label={i18n.t('CEP')}
              value={cep}
              onChange={(value) => {
                setCep(value);
              }}
            />
          </div>
          <div className="col-md-8 ml-2">
            <Input
              className="settings-content-modal-input ipt-rev"
              disabled
              label={i18n.t('Rua')}
              value={address}
              onChange={(value) => {
                setAddress(value);
              }}
            />
          </div>
        </div>

        {/* bairro, cidade, uf, pais */}
        <div className="row">
          <div className="col-md-3 ml-1">
            <Input
              className="settings-content-modal-input ipt-rev"
              disabled
              label={i18n.t('Bairro')}
              value={addressNeighborhood}
              onChange={(value) => {
                setAddressNeighborhood(value);
              }}
            />
          </div>
          <div className="col-md-4 ml-2">
            <Input
              className="settings-content-modal-input ipt-rev"
              disabled
              label={i18n.t('Cidade')}
              value={addressCity}
              onChange={(value) => {
                setAddressCity(value);
              }}
            />
          </div>
          <div className="col-md-1 ml-2">
            <Input
              className="settings-content-modal-input ipt-rev"
              disabled
              label={i18n.t('UF')}
              value={addressState}
              onChange={(value) => {
                setAddressState(value);
              }}
            />
          </div>
          <div className="col-md-2 ml-2">
            <Input
              className="settings-content-modal-input ipt-rev"
              disabled
              label={i18n.t('País')}
              value={addressCountry}
              onChange={(value) => {
                setAddressCountry(value);
              }}
            />
          </div>
        </div>

        <hr />

        {/* email */}
        <div className="row">
          <div className="col-md-6 ml-1">
            <Input
              className="settings-content-modal-input ipt-rev"
              disabled
              label={i18n.t('Email')}
              value={email}
              onChange={(value) => {
                setEmail(value);
              }}
            />
          </div>
          <div className="col-md-4 ml-2">
            <Input
              className="settings-content-modal-input ipt-rev"
              label={i18n.t('Código de usuário (voicebot)')}
              value={codeUser}
              onChange={(value) => {
                setCodeUser(value);
              }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 ml-1">
            <InputDropdown
              className="settings-content-modal-input ipt-rev letsdale"
              label={i18n.t('Permissões')}
              placeholder={i18n.t('Selecione as Permissões.')}
              dropdownItemsList={permissionsUser || []}
              value={checkedPermissions.name}
              onChange={(items) => setCheckedPermissions(items)}
              useCheckbox={false}
              styleWidth="100%"
            />
          </div>
          <div className="col-md-4 ml-2">
            <InputDropdown
              className="settings-content-modal-input ipt-rev"
              label={i18n.t('Setores')}
              placeholder={i18n.t('Selecine os setores.')}
              value={checkedOrganizations.name}
              dropdownItemsList={orgsCompany || []}
              dropdownItemsChecked={checkedOrganizationsIds}
              onChange={(items) => setCheckedOrganizations(items)}
              useCheckbox
              styleWidth="100%"
            />
          </div>
        </div>

        <button
          type="button"
          className="btn btn-primary float-right mb-3"
          onClick={save}
        >
          {i18n.t('salvar')}
        </button>
      </div>
    </Fragment>
  );
};
